module.exports = __webpack_public_path__ + "img/dead-dry-hairy-tree-09.b76c17b8.png";